import { AxiosResponse } from 'axios'
import {
    all,
    call,
    put,
    // select,
    takeLatest,
    AllEffect,
    ForkEffect,
} from 'redux-saga/effects'
import { sagaErrorHandle } from 'utils/errHandle'
import { paletteTypes } from './actionTypes'
import {
    getColorsTemplates,
    getImagesTemplates,
    getChosenPalette,
    editChosenPalette,
} from '../service/palette'

import {
    IPalette,
    IColorPalette,
    IImagePalette,
    FetchTemplatesRequest,
    FetchChosenPaletteRequest,
    EditPaletteRequest,
} from './types'

function* fetchTemplatesSaga(action: FetchTemplatesRequest) {
    try {
        const [colorsResponse, imagesResponse]: [
            AxiosResponse<IColorPalette[]>,
            AxiosResponse<IImagePalette[]>,
        ] = yield all([call(getColorsTemplates), call(getImagesTemplates)])

        if (colorsResponse.data) {
            yield put({
                type: paletteTypes.SET_COLORS_TEMPLATES,
                payload: { colorsTemplates: colorsResponse.data },
            })
        }

        if (imagesResponse.data) {
            yield put({
                type: paletteTypes.SET_IMAGES_TEMPLATES,
                payload: { imagesTemplates: imagesResponse.data },
            })
        }
    } catch (error) {
        sagaErrorHandle(action.payload.callback, error)
    }
}

function* fetchChosenPaletteSaga(action: FetchChosenPaletteRequest) {
    try {
        const response: AxiosResponse<IPalette> = yield call(
            getChosenPalette,
            action.payload,
        )
        if (response.status === 204) {
            yield put({
                type: paletteTypes.SET_PALETTE,
                payload: {
                    palette: {
                        background: '',
                    },
                },
            })
        }
        if (response.status === 200) {
            yield put({
                type: paletteTypes.SET_PALETTE,
                payload: { palette: response.data },
            })
        }
        if (action.payload.callback) {
            action.payload.callback('success', undefined, response.data)
        }
    } catch (error) {
        sagaErrorHandle(action.payload.callback, error)
    }
}

function* editPaletteSaga(action: EditPaletteRequest) {
    try {
        const response: AxiosResponse<IPalette> = yield call(
            editChosenPalette,
            {
                appId: action.payload.appId,
                palette: action.payload.palette,
                designType: action.payload.designType || 'COLOR',
            },
        )

        if (response.status === 200) {
            if (action.payload.callback) {
                action.payload.callback(
                    'success',
                    undefined,
                    action.payload.palette,
                )
            }

            yield put({
                type: paletteTypes.SET_PALETTE,
                payload: { palette: action.payload.palette },
            })
        }
    } catch (error) {
        sagaErrorHandle(action.payload.callback, error)
    }
}

function* paletteSaga(): Generator<
    AllEffect<ForkEffect<never>>,
    void,
    unknown
> {
    yield all([
        takeLatest(paletteTypes.FETCH_TEMPLATES_REQUEST, fetchTemplatesSaga),
    ])
    yield all([
        takeLatest(paletteTypes.FETCH_PALETTE_REQUEST, fetchChosenPaletteSaga),
    ])
    yield all([
        takeLatest(paletteTypes.UPDATE_PALETTE_REQUEST, editPaletteSaga),
    ])
}

export default paletteSaga
